import { render, staticRenderFns } from "./ZyWithoutCodeLogin.vue?vue&type=template&id=edb6186c&scoped=true&"
import script from "./ZyWithoutCodeLogin.vue?vue&type=script&lang=js&"
export * from "./ZyWithoutCodeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6186c",
  null
  
)

export default component.exports